module.exports = __webpack_public_path__ + "static/blog-18-8655a5e43787e5fd72c8919061920c92.png";